import styled from "styled-components/macro";
import {AccountIcon,} from "../../icon/Icon";
import React, {useEffect, useState} from "react";
import {ITab, SideBar} from "./SideBar";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
    GetAvatar,
    GetExternalAccounts,
    GetIdentityCard,
    GetSex,
    GetSnils,
    GetUser,
    onTabClick,
    setNeedUpdate
} from "./AccountInfo/api/slice";
import {AddAvatar} from "./AddAvatar";
import {Header} from "./Header";
import {AccountContent} from "./Content";
import {WindowSizePXEnum} from "../../interface/Basic/window";
import {useTranslation} from "react-i18next";

export enum TabsEnum {
    Account,
    Education,
    Career,
    Security,
    FAQ
}

export const Passport = () => {
    const {addAvatar, needUpdate} = useAppSelector(state => state.account)
    const {token} = useAppSelector(state => state.auth)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const {t} = useTranslation();
    const tabs: ITab[] = [
        {id: TabsEnum.Account, name:  t('passport.account'), icon: AccountIcon},
        // {id: 1, name: TabsEnum.Education, icon: EducationIcon},
        // {id: 2, name: TabsEnum.Career, icon: WorkIcon},
        // {id: 3, name: TabsEnum.Security, icon: SecurityIcon},
        // {id: 4, name: TabsEnum.FAQ, icon: FAQIcon}
    ]

    const dispatch = useAppDispatch()
    const [currentTab, setCurrentTab] = useState<ITab>(tabs[0])

    useEffect(() => {
        if (token) {
            dispatch(GetUser())
            dispatch(GetSnils())
            dispatch(GetSex())
            dispatch(GetIdentityCard())
            dispatch(GetAvatar())
            dispatch(GetExternalAccounts())
            dispatch(GetAvatar())
        }
    }, [token])

    useEffect(() => {
        if (needUpdate === true) {
            dispatch(GetUser())
            dispatch(GetSnils())
            dispatch(GetSex())
            dispatch(GetIdentityCard())
            dispatch(GetAvatar())
            dispatch(GetExternalAccounts())
            dispatch(setNeedUpdate(false))
        }
    }, [needUpdate])

    return (<>{addAvatar &&
        <AddAvatar/> ||
        <AccountContainer>
            <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={() => setMobileMenuOpen(prev => !prev)}/>
            <AccountContentContainer>
                <SideBar
                    setMobileMenuOpen={() => setMobileMenuOpen(prev => !prev)}
                    mobileMenuOpen={mobileMenuOpen}
                    tabs={tabs}
                    currentTab={currentTab}
                    onTabClick={(tab) => {
                        dispatch(onTabClick())
                        setCurrentTab(tab)
                    }}/>
                <AccountContent current={currentTab}/>
            </AccountContentContainer>
        </AccountContainer>
        }
        </>
    )
}

const AccountContainer = styled.div`
  overflow: hidden;
  display: flex;
  width: 100vw;
  min-height: 100vh;
  padding-top: 96px;
  padding-bottom: 20px;
  justify-content: center;
  gap: 32px;
  background: ${({theme}) => theme.color.secondaryBackground};
  @media (max-width: ${WindowSizePXEnum.xs}) {
    padding-top: 56px;
  }
`

const AccountContentContainer = styled.div`
  display: flex;
  gap: 32px;
  height: 100%;
  overflow: initial;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
  }
`